import swal from 'sweetalert2'
import _ from 'lodash'

export default {
  success (options = {}) {
    return swal(_.merge({
      title: 'Success!',
      type: 'success',
      animation: false,
      showConfirmButton: false,
      timer: 2500
    }, options)).catch(error => error)
  },

  confirm (options = {}) {
    return swal(_.merge({
      title: 'Are you sure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#5cb85c',
      cancelButtonColor: '#337ab7',
      animation: false,
      confirmButtonText: 'Yes, I am sure.',
      allowOutsideClick: false
    }, options))
  },

  delete (options = {}) {
    return swal(_.merge({
      title: 'Warning!',
      text: 'Are you sure you want to perform this delete?',
      type: 'error',
      animation: false,
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#5cb85c',
      cancelButtonColor: '#337ab7',
      confirmButtonText: 'Yes, I am sure.',
      allowOutsideClick: false
    }, options))
  },

  changes (options = {}) {
    return swal(_.merge({
      title: 'You have unsaved changes.',
      text: 'Are you sure you want to leave?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#5cb85c',
      cancelButtonColor: '#337ab7',
      animation: false,
      confirmButtonText: 'Yes, continue!',
      allowOutsideClick: false
    }, options))
  },

  error (options = {}) {
    return swal(_.merge({
      title: 'We encountered an error.',
      type: 'error',
      animation: false,
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Okay.'
    }, options))
  },

  warning (options = {}) {
    return swal(_.merge({
      title: 'Important',
      type: 'warning',
      animation: false
    }, options))
  },

  custom (options = {}) {
    return swal(_.merge({
      animation: true
    }, options))
  },

  input (title, emptyValue) {
    return swal({
      title: title,
      input: 'text',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: function (value) {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            if (!value) {
              reject(emptyValue)
            } else {
              resolve()
            }
          }, 2000)
        })
      },
      allowOutsideClick: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/alert.js